// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"901d4bfb","213":"8d189a05","304":"d3dd74a1","389":"704003ce","451":"bafdbb9f","453":"21e9e00e","732":"c1924de9","793":"cf54bf3c","892":"31565924","977":"fdba7d61","990":"57280b97"}[chunkId] + ".chunk.js";
};